import * as Yup from 'yup';

export const emailSchema = Yup.string().email('Invalid email format').required('Email is required');

export const passwordSchema = Yup.string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/[a-z]/, 'Password must contain a lowercase letter')
  .matches(/[A-Z]/, 'Password must contain an uppercase letter')
  .matches(/\d/, 'Password must contain a number')
  .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain a special character')
  .required('Password is required');

export const confirmPasswordSchema = (ref: string) =>
  Yup.string()
    .oneOf([Yup.ref(ref)], 'Passwords do not match')
    .required('Please confirm your password');

export const nameSchema = Yup.string()
  .trim()
  .required('Name is required')
  .min(2, 'Name must be at least 2 characters')
  .max(100, 'Name must be at most 100 characters');

export const sixDigitCodeSchema = Yup.string()
  .matches(/^\d{6}$/, 'Code must be 6 digits')
  .required('Code is required');
